
import Vue from "vue";
import Component from "vue-class-component";
import { State } from "vuex-class";

import ModalAbout from "./ModalAbout.vue";

@Component({
  components: {
    ModalAbout,
  },
})
export default class About extends Vue {
  /* VUEX */

  @State("school", { namespace: "academy" })
  private school: any;

  /* INITIALIZATION */

  private isShowModalAbout: boolean = false;

  constructor() {
    super();
  }
}
